export default __webpack_public_path__ + "static/media/paper.e67a0944.jpg";